import { useShallow } from 'zustand/react/shallow';
import { useScreenshotPopupStore } from '@store/screenshotPopupStore';

export const usePopupContext = () =>
  useScreenshotPopupStore(
    useShallow((s) => ({
      isPopupVisible: s.isPopupVisible,
      showPopup: s.showPopup,
      hidePopup: s.hidePopup,
      streamId: s.streamId,
      updateStreamId: s.updateStreamId,
      fileKeyNames: s.fileKeyNames,
      setFileKeyName: s.setFileKeyName,
    }))
  );
